import { AppCta } from "@components/home/AppCta";
import { Page } from "@components/layout/Page";
import { TextBlock } from "@components/product/Blocks";
import { ProductHero } from "@components/product/ProductHero";
import { Steps } from "@components/shared/Steps";
import { AUTO_LOAN } from "@/lib/site";
import { useTranslations } from "@services/strings";
import Link from "next/link";

const AutoLoansPage = () => {
  const { t, formatNumber } = useTranslations();
  const vars = {
    maxAmount: formatNumber(AUTO_LOAN.maxAmount),
    maxAmountM: formatNumber(AUTO_LOAN.maxAmount / 1_000_000),
    minAmount: formatNumber(AUTO_LOAN.minAmount),
    minAmountK: formatNumber(AUTO_LOAN.minAmount / 1_000),
    maxYears: AUTO_LOAN.maxYears,
  };

  return (
    <Page
      title={t("site.autoLoans.meta.title")}
      description={t("site.autoLoans.meta.description", vars)}
    >
      <ProductHero
        placement="auto-hero"
        eyebrow={t("site.autoLoans.hero.eyebrow")}
        title={t("site.autoLoans.hero.title")}
        subtitle={t("site.autoLoans.hero.subtitle", vars)}
        facts={(["amount", "years", "rate", "min"] as const).map((id) => ({
          value: t(`site.autoLoans.facts.${id}.value`, vars),
          label: t(`site.autoLoans.facts.${id}.label`),
        }))}
      />

      <Steps
        tone="mist"
        title={t("site.autoLoans.steps.title")}
        steps={(["one", "two", "three", "four"] as const).map((id) => ({
          title: t(`site.autoLoans.steps.items.${id}.title`),
          body: t(`site.autoLoans.steps.items.${id}.body`),
        }))}
      />

      <TextBlock title={t("site.autoLoans.note.title")}>
        <p>
          {t("site.autoLoans.note.body")}{" "}
          <Link
            href="/unlock"
            className="font-semibold text-ink underline decoration-mint decoration-2 underline-offset-4"
          >
            {t("site.nav.unlock")}
          </Link>
        </p>
      </TextBlock>

      <AppCta
        placement="auto-cta"
        title={t("site.autoLoans.cta.title")}
        body={t("site.autoLoans.cta.body")}
      />
    </Page>
  );
};

export default AutoLoansPage;
